module.exports = __webpack_public_path__ + "static/media/softwareDev.256c0430.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/softwareDev.png
// module id = 866
// module chunks = 6